'use strict';

//TODO not working on dashboard and salary overview
import { addExportBtns, getSelectedCompany, isUserClient } from "./jquery-functions-library";
import { addExportBtns as addExportBtnsVoucher} from "./voucher/voucher-table-export";
import {element_exists} from "./functions";

export var fnTableSettings = function () {
    var table = $('#pjax-container').find('table.dataTable');
    var filterThese = ['datatable-customer-employees', 'datatable-customer-employees'];
    var filterTheseWithGlobal = ['datatable-users'];

    if (table.is(':visible')) {
        $.fn.dataTable.ext.search.push(
            function (settings, data, dataIndex) {

                var company_id = getSelectedCompany();
                if (filterTheseWithGlobal.indexOf(settings.sTableId) !== -1 && element_exists('#selected_company')) {
                    if (company_id !== undefined && company_id !== '0' && company_id !== 'default' && company_id !== null) {
                        return isUserClient(data[0], company_id);
                    } else {
                        return true;
                    }
                }
                if (filterThese.indexOf(settings.sTableId) !== -1 && element_exists('#selected_company')) {

                    if (company_id !== undefined && company_id !== '0' && company_id !== 'default' && company_id !== null) {
                        return isUserClient(data[0], company_id);
                    }
                    return false;
                }
                return true;
            }
        );

        if (table[1] && ($(table[1]).attr('id') === 'datatable-vouchers' || $(table[1]).attr('id') === 'datatable-vouchers-earlier-releases')) {
            let amountCol = $(table[1]).attr('id') === 'datatable-vouchers' ? 4 : 3;
            addExportBtnsVoucher(table, amountCol);
        } else {
            addExportBtns(table);
        }
    }
    else {
        $('.btn-export-table').hide();
    }
    $('.dataTables_filter label').find('input').addClass('form-control');
    $('.dataTables_length label').find('select').addClass('form-control');
};